import type { ReactNode } from 'react'
import type { LucideIcon } from 'lucide-react'

/**
 * Empty / filtered-empty view: icon, title, one-line guidance, optional
 * CTA. Per doctrine, blank screens are defects — use this instead.
 */

export interface EmptyStateProps {
  icon?: LucideIcon
  title: string
  hint?: string
  action?: ReactNode
}

export function EmptyState({ icon: IconCmp, title, hint, action }: EmptyStateProps) {
  return (
    <div className="it-empty">
      {IconCmp && (
        <span className="it-empty__icon">
          <IconCmp size={22} strokeWidth={1.5} aria-hidden="true" />
        </span>
      )}
      <div className="it-empty__title">{title}</div>
      {hint && <div className="it-empty__hint">{hint}</div>}
      {action && <div className="it-empty__action">{action}</div>}
    </div>
  )
}
